function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Xl/Portal-Asociado-Menu",
  transform: "translate(-113.000000, -883.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "component/Xs/Menu/Portal/Nl+sociales-Copy-4",
  transform: "translate(47.000000, 883.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-icon/60X60/twitter-Naranja",
  transform: "translate(66.666667, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "twetter-copy",
  fill: "#0E76A8"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-3-Copy",
  cx: 24.9542269,
  cy: 24.9542269,
  r: 24.9542269
})), /*#__PURE__*/React.createElement("g", {
  id: "sc-linkedin-copy",
  transform: "translate(13.333333, 13.333333)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.6074977,0 L1.72134826,0 C0.771824557,0 0,0.752948718 0,1.68269231 L0,21.6497436 C0,22.5785897 0.771824557,23.3333333 1.72134826,23.3333333 L21.6074977,23.3333333 C22.5588164,23.3333333 23.3333333,22.5785897 23.3333333,21.6497436 L23.3333333,1.68269231 C23.3333333,0.752948718 22.5588164,0 21.6074977,0 L21.6074977,0 Z M3.58988166,8.97435897 L7.17976332,8.97435897 L7.17976332,19.7435897 L3.58988166,19.7435897 L3.58988166,8.97435897 Z M5.38571996,7.53846154 C4.19298178,7.53846154 3.2308935,6.57371795 3.2308935,5.38461538 C3.2308935,4.19551282 4.19298178,3.23076923 5.38571996,3.23076923 C6.57397079,3.23076923 7.53875149,4.19551282 7.53875149,5.38461538 C7.53875149,6.57371795 6.57397079,7.53846154 5.38571996,7.53846154 L5.38571996,7.53846154 Z M19.7443491,19.7435897 L16.1544675,19.7435897 L16.1544675,14.3589744 C16.1544675,12.900641 15.7613754,11.515 14.3595266,11.515 C12.9567804,11.515 12.5645858,12.9221795 12.5645858,14.3751282 L12.5645858,19.7435897 L8.97470416,19.7435897 L8.97470416,8.97435897 L12.5645858,8.97435897 L12.5645858,10.269359 L12.7440799,10.269359 C13.2053797,9.39435897 14.3595266,8.65038462 15.7317589,8.65038462 C19.0434247,8.65038462 19.7443491,10.8257692 19.7443491,13.4615385 L19.7443491,19.7435897 L19.7443491,19.7435897 Z",
  id: "Fill-3"
}))))));

function SvgLogoLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "50px",
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A75F6DAF-0E21-4AFD-BB06-E0982EE64628") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo-linkedin.b9522ebd.svg";
export { ForwardRef as ReactComponent };